"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSchemaUtils = exports.dataSchemaUtilsSchema = void 0;
const tslib_1 = require("tslib");
const jsonSchema_1 = require("@tencent/data-schema-core/lib/convertor/jsonSchema");
const jsonData_1 = require("@tencent/data-schema-core/lib/convertor/jsonData");
const data_schema_core_1 = require("@tencent/data-schema-core");
const typescript_1 = require("@tencent/data-schema-core/lib/convertor/typescript");
const dataSchemaFactory_1 = require("./dataSchemaFactory");
const { method, variable, wholeSchema } = (0, dataSchemaFactory_1.createDataSchemaFactory)({
    title: 'data-schema 工具包',
});
class DataSchemaUtils {
    constructor() {
        this.DataStub = data_schema_core_1.DataStub;
    }
    fromJSONSchema(schema) {
        return (0, jsonSchema_1.fromJSONSchema)(schema);
    }
    fromJsonData(data) {
        return (0, jsonData_1.fromJsonData)(data);
    }
    toTypeScript(schema, opts) {
        return (0, typescript_1.dataSchemaToTSDeclaration)(schema, opts);
    }
    getDefaultValue(schema, opts) {
        return (0, data_schema_core_1.getDefaultValue)(schema, opts);
    }
    mergeDataSchema(a, b) {
        return (0, data_schema_core_1.mergeDataSchema)(a, b);
    }
}
tslib_1.__decorate([
    method({
        description: '将 JSON Schema 转换成 data-schema',
        arguments: [{ id: 'schema', type: 'object', required: true }],
    })
], DataSchemaUtils.prototype, "fromJSONSchema", null);
tslib_1.__decorate([
    method({
        description: '将 JSON 数据转换成 data-schema（尽量避免数据有空数组，会导致不准确！）',
        arguments: [{ id: 'data', type: 'object', required: true }],
    })
], DataSchemaUtils.prototype, "fromJsonData", null);
tslib_1.__decorate([
    method({
        description: '将 data-schema 转换成 typescript 类型定义',
        arguments: [
            {
                id: 'schema', type: 'object', required: true,
            },
            {
                id: 'opts', type: 'object', required: false, fields: [
                    { id: 'typePrefix', type: 'string', description: '类型前面加 `declare` 或者 `export` 之类的前缀，可以用这个配置' },
                ],
            },
        ],
    })
], DataSchemaUtils.prototype, "toTypeScript", null);
tslib_1.__decorate([
    method({
        description: '基于 DataSchema 对象，生成默认值',
        arguments: [
            {
                id: 'schema', type: 'object', required: true,
            },
            {
                id: 'opts', type: 'object', required: false, fields: [
                    { id: 'exprContext', type: 'object', description: ' 执行表达式（比如 `default: {$expr: "1+1"}` 或者字段的 condition）的时候，使用的上下文' },
                    { id: 'includeOptional', type: 'boolean', description: '默认会抛弃 required 为 false 的 field，如果需要的话，可将这个选项开启' },
                    { id: 'mockArrayItems', type: 'number', description: '如果是数组，是否生成几个子元素？默认 0，表示不需要' },
                    { id: 'useLorem', type: 'any', description: '是否生成一些随机值？可以为 true，或者一个 `(schema)=>any` 的生成函数' },
                    { id: 'ignoreCondition', type: 'boolean', description: '是否忽略 condition 保留全部的字段，默认为 false' },
                ],
            },
        ],
    })
], DataSchemaUtils.prototype, "getDefaultValue", null);
tslib_1.__decorate([
    method({
        description: '合并两个 DataSchema，补全各种缺失的字段',
        arguments: [
            { id: 'a', type: 'object', required: true },
            { id: 'b', type: 'object', required: true },
        ],
    })
], DataSchemaUtils.prototype, "mergeDataSchema", null);
tslib_1.__decorate([
    variable({
        description: 'DataStub类，可以用 `new DataStub({ schema, value?, parent? })` 来创建一个 DataStub 对象',
    })
], DataSchemaUtils.prototype, "DataStub", void 0);
exports.dataSchemaUtilsSchema = wholeSchema;
exports.dataSchemaUtils = new DataSchemaUtils();
